import React, { useState, useEffect } from "react";
import './HomePage.css';
import axios from "axios";
import { ActionIcon, Container, createStyles, Drawer, Grid, Group, LoadingOverlay, Pagination, Text, TextInput } from "@mantine/core";
import Filter from "../../components/Filter/Filter";
import ProductCard from "../../components/ProductCard/ProductCard";
import ContactUs from "../../components/ContactUs/ContactUs";
import HeaderHero from "../../components/HeaderHero/HeaderHero";
import { useMediaQuery } from "@mantine/hooks";
import { Filter as FilterIcon } from "tabler-icons-react";
import { useWindowScroll } from '@mantine/hooks';
import Maps from "../../components/Maps/Maps"

const useStyles = createStyles((theme) => ({
    filtersContainer: {
        [theme.fn.smallerThan("sm")]: {
            display: "none",
        },
    },
}));

const HomePage = (props) => {
    const [scroll, scrollTo] = useWindowScroll();
    const { classes, cx } = useStyles();
    const matches = useMediaQuery("(min-width: 769px)");
    const [opened, setOpened] = useState(false);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState("");

    const [filters, setFilters] = useState({
        titles: [],
        types: [],
        gear: [],
        fuelType: [],
        passengers: [],
    });
    const [activePage, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [loader, setLoader] = useState(true);



    const loaderFunc = () => {
        return (
            <LoadingOverlay
                visible={loader}
                loaderProps={{ size: 'xl', variant: 'bars' }}
                overlayOpacity={0.5}
                exitTransitionDuration={2000}
            />
        );
    }

    const getCars = async () => {
        try {
            let url = `https://cars-rent-api.herokuapp.com/cars/?limit=9&offset=${activePage - 1}&`;
            Object.keys(filters).forEach((key) => {
                if (
                    filters[key] &&
                    Array.isArray(filters[key]) &&
                    filters[key].length > 0
                ) {
                    url += `${key}=${filters[key].join(",")}&`;
                } else if (filters[key] && !Array.isArray(filters[key])) {
                    url += `${key}=${filters[key]}&`;
                }
            });

            if (search.length > 0) {
                url += `search=${search}`;
            }


            const resp = await axios.get(url);
            setData(resp.data.data);
            setTotalPages(resp.data.total);
        } catch (error) {
            console.log(error);
        }
        setTimeout(() => {
            setLoader(false);
        }, 1500);
    };

    useEffect(() => {
        getCars();
    }, []);

    useEffect(() => {
        getCars();
    }, [filters, search, activePage,]);

    useEffect(() => {
        setPage(1);
    }, [filters, search]);



    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }


    return (
        <>
            {setTimeout(() => {
                setLoader(false);
            }, 1500) && (loaderFunc())}
            <Container size={1500}>
                <HeaderHero />
                <main className="main">
                    <Grid gutter={"xl"}>
                        <Grid.Col span={2} className={classes.filtersContainer}>
                            {!matches ? (
                                <Drawer
                                    opened={opened}
                                    onClose={() => setOpened(false)}
                                    size={"lg"}
                                >
                                    <Group
                                        px="lg"
                                        styles={{ root: { overflowY: "scroll", height: "90%" } }}
                                    >
                                        <Filter filters={filters} setFilters={setFilters} capitalizeFirstLetter={capitalizeFirstLetter} />
                                    </Group>
                                </Drawer>
                            ) : (
                                <Filter
                                    opened={opened}
                                    setOpened={setOpened}
                                    filters={filters}
                                    setFilters={setFilters}
                                    capitalizeFirstLetter={capitalizeFirstLetter}
                                />
                            )}
                        </Grid.Col>
                        <Grid.Col span={matches ? 10 : 12}>
                            <Grid>
                                <Grid.Col span={8} style={{ alignSelf: 'end', padding: 4, }}>
                                    {!matches && (
                                        <ActionIcon size="xl" onClick={() => setOpened(true)}>
                                            <FilterIcon
                                                size={38}
                                                strokeWidth={2}
                                                color={'#417E27'}
                                            />
                                        </ActionIcon>
                                    )}
                                </Grid.Col>
                                <Grid.Col span={4}>
                                    <TextInput
                                        placeholder="Search your favorite car"
                                        label="Search cars"
                                        radius="md"
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </Grid.Col>
                                {data.length > 0 ?
                                    (data.map((product, index) => (<Grid.Col xs={6} lg={4}>
                                        <ProductCard key={index + 1} product={product} capitalizeFirstLetter={capitalizeFirstLetter} />
                                    </Grid.Col>)))
                                    :
                                    (<Text size="xl" weight={700} style={{ textAlign: 'center', margin: '0 auto', marginTop: '50px' }}>
                                        Sorry, but car not found.<br />Please, try again</Text>)}
                            </Grid>
                        </Grid.Col>
                        <Grid.Col span={12}>
                            <Pagination page={activePage} onChange={setPage} total={totalPages} style={{ justifyContent: 'center' }} onClick={() => scrollTo({ y: 520 })} />
                        </Grid.Col>
                    </Grid>
                </main>
                <Maps />
                <ContactUs p={0} />
            </Container >
        </>
    );
}

export default HomePage;